"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var button_1 = require("ayvri-ui/lib/button");
var React = require("react");
var react_redux_1 = require("react-redux");
var footer_1 = require("../../clean-components/footer");
var comment_1 = require("../../components/comment/comment");
var follow_1 = require("../../components/follow");
var header_1 = require("../../components/header");
var profile_1 = require("../../components/profile");
var sceneDetails_1 = require("./sceneDetails");
require("../../pages/global.css");
// tslint:disable-next-line:no-var-requires
var styles = require('./scene.css');
exports.SceneJSX = function (store, features, options) {
    var allowGlobeToggle = options && options.allowGlobeToggle;
    var globeEnabled = options && options.globeEnabled;
    return (React.createElement("div", null,
        React.createElement(react_redux_1.Provider, { store: store },
            React.createElement("div", { className: 'scenePageHeader' },
                React.createElement(header_1.Header, null))),
        React.createElement("div", null,
            React.createElement("div", { key: 'player', className: styles.hero },
                React.createElement("div", { id: 'player', className: styles.player })),
            React.createElement(react_redux_1.Provider, { store: store },
                React.createElement("div", null,
                    React.createElement("div", { key: 'globe-toggle', className: styles.globePrompt }, features.allow_globe_toggle ? renderGlobeToggle(options) : false),
                    React.createElement("div", { key: 'scene-content', className: styles.sceneContent },
                        React.createElement("div", null,
                            React.createElement(sceneDetails_1.SceneDetails, { features: features }),
                            React.createElement(comment_1.Comments, null)),
                        React.createElement("div", null,
                            React.createElement("div", { className: styles.mobileTitle }, store.getState().scene.title),
                            React.createElement("div", { className: styles.profileContent },
                                React.createElement(profile_1.Profile, null),
                                store.getState().user.handle !== store.getState().scene.accountId ? React.createElement(follow_1.FollowButton, null) : ''))),
                    React.createElement(footer_1.Footer, null),
                    React.createElement("div", null))))));
    function renderGlobeToggle(props) {
        if (!allowGlobeToggle) {
            return null;
        }
        return (React.createElement("div", { className: styles.globePromptContent },
            React.createElement("div", { key: 'intro' }, globeEnabled ? (React.createElement("span", null,
                "You are currently using the beta version of the new player. We'd love to hear any",
                ' ',
                React.createElement("a", { className: styles.feedback, href: 'mailto:hello@ayvri.com?subject=Globe Feedback' }, "feedback"),
                ' ',
                "you may have.")) : (React.createElement("span", null, "Ayvri is currently trialling a new player. If you would like to try the new player, then hit the \"Try it now\" button. You can switch back at anytime."))),
            React.createElement("div", { className: styles.globePromptButton }, globeEnabled ? renderRollbackButton() : renderTryButton())));
        function renderTryButton() {
            return (React.createElement(button_1.Button, { type: 'primary', size: 'large', onClick: function () { return useGlobe('ayvri'); } }, "Try it now!"));
        }
        function renderRollbackButton() {
            return (React.createElement(button_1.Button, { type: 'primary', size: 'large', onClick: function () { return useGlobe('cesium'); } }, "Use original player"));
        }
        function useGlobe(globe) {
            props.setBetaGlobeSetting(globe);
            location.reload();
        }
    }
};
